export default __webpack_public_path__ + "static/avatar2-afa90500288463fdec12bb10a0f7f70b.jpg";